import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Tooltip } from "@mui/material";
import GlobalDropdownField from "./GlobalDropdownField";
import GlobalButton from "../utils/GlobalButton";

function DatePickerValue({
  onSubmit,
  setAnchorEl,
  operation,
  props,
  allIps,
  isIpId,
  setIsIpId,
}) {
  const [fromDate, setFromDate] = React.useState(dayjs());
  const [toDate, setToDate] = React.useState(dayjs());
  const [error, setError] = React.useState("");
  const containerRef = React.useRef(null);

  const handleButtonClick = () => {
    if (fromDate.isAfter(toDate)) {
      setError("From date cannot be after To date.");
      return;
    }
    setError("");
    onSubmit(fromDate, toDate);
    setAnchorEl(null);
  };
  const handleIpChange = (e) => {
    setIsIpId(e.target.value);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{ display: "flex", flexDirection: "column", gap: "16px" }}
        ref={containerRef} // Attach ref to the container
      >
        {operation == "payment" && (
          <GlobalDropdownField
            variant="citySelect"
            name="city"
            value={isIpId || ""}
            onChange={handleIpChange}
            placeholder="Select IP"
            options={[
              { value: "", label: "All IPs" },
              ...(allIps?.map((ele) => ({
                value: ele.id,
                label: ele.name,
              })) || []),
            ]}
            renderValueFn={(selected) => {
              if (!selected) return "All IPs";

              const ip = allIps?.find((ele) => ele.id === selected);
              return ip?.name || "Select IP";
            }}
          />
        )}
        <DatePicker
          label="From"
          value={fromDate}
          onChange={(newValue) => {
            if (newValue) setFromDate(newValue);
          }}
          format="DD/MM/YY"
          slotProps={{ textField: { size: "small", fullWidth: true } }}
        />
        <DatePicker
          label="To"
          value={toDate}
          onChange={(newValue) => {
            if (newValue) setToDate(newValue);
          }}
          format="DD/MM/YY"
          slotProps={{ textField: { size: "small", fullWidth: true } }}
        />
        {error && <Box sx={{ color: "red" }}>{error}</Box>}{" "}
        <GlobalButton
          variant="primary"
          size="medium"
          onClick={handleButtonClick}
        >
          {operation == "payment" ? "Download" : "Filter Date"}
        </GlobalButton>
      </Box>
    </LocalizationProvider>
  );
}

export default function MenuButtonWithDatePickers({
  operation = null,
  onSubmit,
  anchorEl,
  setAnchorEl,
  handleClose,
  handleClick,
  clearDateFilter,
  allIps,
  setIsIpId,
  isIpId,
}) {
  const handleClose1 = () => {
    setAnchorEl(null);
  };

  const handleSubmitDates = (fromDate, toDate) => {
    const toDateEndOfDay = toDate.endOf("day"); // This ensures toDate is end of day

    // Now we format it correctly, keeping the time for toDate
    const formattedFromDate = fromDate.format("YYYY-MM-DD 00:00:00");
    const formattedToDate = toDateEndOfDay.format("YYYY-MM-DD HH:mm:ss");

    if (toDateEndOfDay) {
      // setAnchorEl(null);
      onSubmit({
        dateFilter: {
          fromDate: formattedFromDate,
          toDate: formattedToDate,
        },
      });
    } else {
      console.error("To Date is not selected.");
    }
  };

  return (
    <div
      className={`cursor-pointer ${
        operation == "payment"
          ? "bg-blue-400 text-white rounded-full px-3 flex justify-between gap-3 items-center"
          : ""
      }`}
      onClick={operation == "payment" ? handleClick : undefined}
    >
      {operation == "payment" && (
        <div className="py-1.5 flex gap-1">
          <p className=" text-[14px] text-white">Payments</p>
          <FilterAltOutlinedIcon
            sx={{
              color: "#ffffff",
              height: 18,
              width: 18,
            }}
          />
        </div>
      )}
      {operation != "payment" && (
        <Tooltip title="Filter">
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleClick}
          >
            <FilterAltOutlinedIcon
              sx={{
                color: "#666666",
                height: 24,
                width: 24,
              }}
            />
          </IconButton>
        </Tooltip>
      )}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose1}
        keepMounted
      >
        <MenuItem>
          <DatePickerValue
            key={clearDateFilter ? `reset-${Date.now()}` : "active"}
            onSubmit={handleSubmitDates}
            setAnchorEl={setAnchorEl}
            operation={operation}
            allIps={allIps}
            isIpId={isIpId}
            setIsIpId={setIsIpId}
          />
        </MenuItem>
      </Menu>
    </div>
  );
}
